var map = {
	"./additionalInfoIcon.svg": 663,
	"./arrowLeftIcon.svg": 664,
	"./arrowMediumTop.svg": 665,
	"./arrowRightIcon.svg": 666,
	"./arrowRightIconSharp.svg": 667,
	"./arrowRightSmallIcon.svg": 668,
	"./arrowScalableIcon.svg": 669,
	"./arrowSelect2.svg": 670,
	"./arrowSelectIcon.svg": 671,
	"./benefit1.svg": 672,
	"./benefit2.svg": 673,
	"./benefit3.svg": 674,
	"./cardsIcon.svg": 675,
	"./copyIcon copy.svg": 676,
	"./copyIcon.svg": 677,
	"./crossIcon.svg": 678,
	"./crossIcon2.svg": 679,
	"./crossIcon3.svg": 680,
	"./crossIconSmall.svg": 681,
	"./crossSmallIcon.svg": 682,
	"./defaultCategoryIcon.svg": 683,
	"./depNumberIcon.svg": 684,
	"./elfCentralIcon.svg": 685,
	"./equalitySign.svg": 686,
	"./errorIcon.svg": 687,
	"./eyeClosedIcon.svg": 688,
	"./eyeOpenIcon.svg": 689,
	"./favoritesIcon.svg": 690,
	"./favoritesLabelIcon.svg": 691,
	"./filterDivider.svg": 692,
	"./filterIcon.svg": 693,
	"./frequencyIcon.svg": 694,
	"./fsAmountIcon.svg": 695,
	"./fullScreenIcon.svg": 696,
	"./gameIcon.svg": 697,
	"./hamburgerIcon.svg": 698,
	"./infoIcon.svg": 699,
	"./infoSymbol.svg": 700,
	"./levelBackground.svg": 701,
	"./levelBackgroundNew.svg": 702,
	"./linkIcon.svg": 703,
	"./lockIcon.svg": 704,
	"./lockSharpIcon.svg": 705,
	"./maxBonusAmountIcon.svg": 706,
	"./maxWinFsIcon.svg": 707,
	"./menu/fortuneIcon.svg": 421,
	"./menu/fortuneIconL.svg": 422,
	"./menu/helpdeskIcon.svg": 423,
	"./menu/helpdeskIconL.svg": 424,
	"./menu/homeIcon.svg": 425,
	"./menu/homeIconLarge.svg": 426,
	"./menu/jackpotIcon.svg": 427,
	"./menu/logo.svg": 428,
	"./menu/logoSmall.svg": 429,
	"./menu/loyaltyIcon.svg": 430,
	"./menu/mobileAppIcon.svg": 431,
	"./menu/profileIcon.svg": 432,
	"./menu/questIcon.svg": 433,
	"./menu/rewardLineupIcon.svg": 434,
	"./menu/searchIcon.svg": 435,
	"./menu/searchIconLarge.svg": 436,
	"./menu/signOutIcon.svg": 437,
	"./menu/star.svg": 438,
	"./menu/tournamentIcon.svg": 439,
	"./menu/tournamentLargeIcon.svg": 440,
	"./menu/vipIcon.svg": 441,
	"./menu/wheelIcon.svg": 442,
	"./menu/wheelIconL.svg": 443,
	"./menu/wheelIconMobile.svg": 444,
	"./menuIcon.svg": 708,
	"./minDepIcon.svg": 709,
	"./noTournamentIcon.svg": 710,
	"./numbers/number-1.svg": 445,
	"./numbers/number-2.svg": 446,
	"./numbers/number-3.svg": 447,
	"./numbers/number-4.svg": 448,
	"./numbers/number-5.svg": 449,
	"./numbers/number-6.svg": 450,
	"./numbers/number-7.svg": 451,
	"./numbers/number-8.svg": 452,
	"./numbers/number-9.svg": 453,
	"./numbers/number-shine-1.svg": 454,
	"./numbers/number-shine-2.svg": 455,
	"./numbers/number-shine-3.svg": 456,
	"./numbers/number-shine-4.svg": 457,
	"./numbers/number-shine-5.svg": 458,
	"./numbers/number-shine-6.svg": 459,
	"./numbers/number-shine-7.svg": 460,
	"./numbers/number-shine-8.svg": 461,
	"./numbers/number-shine-9.svg": 462,
	"./playIcon.svg": 711,
	"./polygon.svg": 712,
	"./preloaderDotsAnimation.svg": 713,
	"./preloaderSpinnerAnimation.svg": 714,
	"./presentIcon.svg": 715,
	"./promoIcon.svg": 716,
	"./recentIcon.svg": 717,
	"./search2Icon.svg": 718,
	"./search3Icon.svg": 719,
	"./sharpTickIcon copy.svg": 720,
	"./sharpTickIcon.svg": 721,
	"./smallInfoSymbol.svg": 722,
	"./smoothArrowIcon.svg": 723,
	"./successIcon.svg": 724,
	"./supportIcon.svg": 725,
	"./tag1Icon.svg": 726,
	"./tag2Icon.svg": 727,
	"./tag3Icon.svg": 728,
	"./tag4Icon.svg": 729,
	"./tickIcon.svg": 730,
	"./unverified.svg": 731,
	"./verified.svg": 732,
	"./wagerIcon.svg": 733,
	"./wagerTimeIcon.svg": 734,
	"./warningIcon.svg": 735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 662;